/**********************/
const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    )
    return result
  }, {})
}
/**********************/

const SETBUSINESSUNITLIST = (state, list) => {
  state.businessUnitList = list
}

const SETNPSSTATEMENTREPORT = (state, list) => {
  if (list.length > 0) {
    const arr1 = list.map((a) => a.unidade)
    const arr2 = list.map((a) => a.positiveScore)
    const arr3 = list.map((a) => a.negativeScore)
    const positive = list
      .map((a) =>
        a.listPositive.reduce((a, c) => {
          a[c] = (a[c] || 0) + 1
          return a
        }, Object.create(null))
      )
      .map((a) => ({ nota: Object.keys(a), total: Object.values(a) }))
      .map((a) => a.nota.map((b, i) => `[${b}]: ${a.total[i]}`))
    const negative = list
      .map((a) =>
        a.listNegative.reduce((a, c) => {
          a[c] = (a[c] || 0) + 1
          return a
        }, Object.create(null))
      )
      .map((a) => ({ nota: Object.keys(a), total: Object.values(a) }))
      .map((a) => a.nota.map((b, i) => `[${b}]: ${a.total[i]}`))

    const obj = {
      labels: arr1,
      original: list,
      datasets: {
        positivas: {
          label: 'Novas Positivas [7-10]',
          data: arr2,
          backgroundColor: '#3299a8',
          stack: 'Stack 1',
          source: positive
        },
        negativas: {
          label: 'Novas Negativas [0-6]',
          data: arr3,
          backgroundColor: '#f23322',
          stack: 'Stack 1',
          source: negative
        }
      }
    }

    state.npsStatementReport = obj
  } else {
    state.npsStatementReport = list
  }
}

const SETNPSCOUNTBYUNITREPORT = (state, list) => {
  const obj = {
    labels: list.map((a) => a.unidade),
    datasets: [
      {
        label: 'Quantidade por unidade de negócio',
        data: list.map((a) => a.total),
        backgroundColor: '#54534f'
      }
    ]
  }

  state.npsCountByUnitReport = obj
}

const SETNPSDETAILSREPORT = (state, list) => {
  state.npsDetailsReport = list.map((a) => ({
    ...a,
    dataHora: `${new Date(
      Date.parse(a.dataHora)
    ).toLocaleDateString()} ${new Date(
      Date.parse(a.dataHora)
    ).toLocaleTimeString()}`
  }))
}

const SETOPHISTSOLBYUNIT = (state, list) => {
  state.opHistSolByUnit = list
}

const SETSOLICITATIONBYSERVICE = (state, list) => {
  // Cria lista com reduce para agrupar por serviço e somar totais
  const arr = list.reduce((res, value) => {
    if (!res[value.service]) {
      res[value.service] = { service: value.service, total: 0 }
    }
    res[value.service].total += value.total

    return res
  }, {})

  // Extrai lista de objeto retornado do reduce
  const result = Object.entries(arr).map((a) => a[1])

  // Cria objeto a ser lido pelo plugin GoogleCharts.
  const obj = result.map((a) => [
    a.service,
    a.total,
    `${a.total} <p> ${Object.entries(groupBy(list, 'service'))
      .filter((b) => b[0] === a.service)
      .map((c) =>
        c[1].map((d) => `<p><b>${d.unidade}: </b> ${d.total}</p>`).join('')
      )
      .toString()}</p>`
  ])

  state.solicitationByService = obj
}

const SETSOLICITATIONBYSTATUS = (state, list) => {
  const x = []
  const usingDates = []
  list.forEach((element) => {
    if (!usingDates.includes(element.data)) {
      const arr = []
      for (let i = 0; i < list.length; i++) {
        if (element.data === list[i].data) {
          arr.push({ status: list[i].status, total: list[i].total })
        }
      }
      x.push({ date: element.data, source: arr })
      usingDates.push(element.data)
    }
  })
  console.log(x)
  state.solicitationyStatus = x
}

const SETLATESOLICITATIONS = (state, list) => {
  if (list.length > 0) {
    const listMap = Object.entries(
      groupBy(
        list.map((a) => ({
          data: a.date,
          atraso: a.diasEmAtraso,
          unidade: a.unidade
        })),
        'unidade'
      )
    )

    state.lateSolicitations = [listMap, list]
  } else {
    state.lateSolicitations = list
  }
}

const SETLATESOLICITATIONSDOWNLOAD = (state) => {
  state.lateSolicitarionsDownload += 1
}

const SETSOLICITATIONSBYUSERPROFILE = (state, list) => {
  state.solicitationsByUserProfile = list
}

const SETBYUSERPERDAY = (state, list) => {
  state.solicitationsByUserPerDay = list
}

const SETGENERALTOTALSOLICITATIONSPERUSER = (state, list) => {
  state.generalTotalSolicitationsPerUser = list
}

const SETAVERAGESOLICITATIONSPERUSER = (state, list) => {
  state.averageSolicitationsPerUser = list
}

const SETTOTALNEWSOLICITATIONSINDAY = (state, val) => {
  state.totalNewSolicitationsInDay = val
}

const SETAVARAGENEWSOLICITATIONSINPERIOD = (state, val) => {
  state.avarageNewSolicitationsInPeriod = val
}

const SETAPPROVEDSOLICITATIONSBYUNITINPERIOD = (state, list) => {
  state.approvedSolicitationsByUnitInPeriod = list
}

const SETTOTALUSERSBYPROFILE = (state, list) => {
  state.totalUsersByProfile = list
}

const SETTOTALUSERSBYUNIT = (state, list) => {
  state.totalUsersByUnit = list
}

export default {
  SETBUSINESSUNITLIST,
  SETNPSSTATEMENTREPORT,
  SETNPSCOUNTBYUNITREPORT,
  SETNPSDETAILSREPORT,
  SETOPHISTSOLBYUNIT,
  SETSOLICITATIONBYSERVICE,
  SETSOLICITATIONBYSTATUS,
  SETLATESOLICITATIONS,
  SETLATESOLICITATIONSDOWNLOAD,
  SETSOLICITATIONSBYUSERPROFILE,
  SETBYUSERPERDAY,
  SETGENERALTOTALSOLICITATIONSPERUSER,
  SETAVERAGESOLICITATIONSPERUSER,
  SETTOTALNEWSOLICITATIONSINDAY,
  SETAVARAGENEWSOLICITATIONSINPERIOD,
  SETAPPROVEDSOLICITATIONSBYUNITINPERIOD,
  SETTOTALUSERSBYPROFILE,
  SETTOTALUSERSBYUNIT
}
